import { Injectable } from '@angular/core';
import { worldCurrencies } from './currencies';
import { StorageKeysEnum } from '../../enums/storage-key.enum';
import { UserInfo } from '../../models/user-info/user-info.model';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  public hiddingFirstNumbers(numeroCompleto: string): string {
    const longitud = numeroCompleto.length;
    
    if (longitud >= 4) {
      const ultimosCuatroDigitos = numeroCompleto.substring(longitud - 4);
      const asteriscos = '*'.repeat(longitud - 4);
      return asteriscos + ultimosCuatroDigitos;
    } else if (longitud >= 1) {
      const ultimoDigito = numeroCompleto.substring(longitud - 1);
      const asteriscos = '*'.repeat(longitud - 1); 
      return asteriscos + ultimoDigito;
    } else {
      return numeroCompleto; 
    }
  }

  getCurrencySymbol(currencyToCompare: string) { 
    const currency = worldCurrencies.find(c => {
      return c.currency === currencyToCompare
    })
    return currency
  }

  getUserInfoSessionStorage(): UserInfo {
    const userInfoString: any = sessionStorage.getItem(StorageKeysEnum.USER_INFO);
    const userInfo = userInfoString ? JSON.parse(userInfoString) : {};
    const contractSelected = Array.isArray(userInfo?.contrato) ? userInfo?.contrato[0] : userInfo.contrato;
    return contractSelected;
  }

  isHoveredClass(currency: any, receiverCurrency: string): boolean {
    const balance = currency.balance.toString().replace(/\,/g, '');
    return (
      currency.cveCurrency === receiverCurrency &&
      Number(balance) > 0
    );
  }

  transformIntoNumber(balance: string): number {
    const number = balance.replace(/,/g, '')
    return Number(number)
  }

  isBalanceNegative(currency: any, receiverCurrency: string): boolean  {
    const balance = currency.balance.toString().replace(/\,/g, '');
    return (
      currency.cveCurrency === receiverCurrency &&
      Number(balance) <= 0
    );
  }
}
